export class Course{
  id: string;
  _id: string;
  title: String;
  image: String;
  about: String;
  serviceandoffer: String;
  preliminary: String;
  benifits: String;
  announcements: String;
  course_type: { };
  total_fees:  Number;
  lsm_ids: []
  variations: { };
  course_tags: [];
  course_category: [];
  batch_ids: {};
  course_skills: [];
  sections: [];
  instructor: [];
  proofreaders: [];
  publishers: [];
  projects: [];
  resources: [];
  last_published_by: { };
  duration: { };
  category: [];
  level: { };
  grading: 'true';
  offer: string;
  certification: 'true';
  published_datetime: string;
  version: string;
  language: [];
  notes: string;
  published_web: boolean=false;
  published_app: boolean=false;
  admin_notes: string;
  learning_audience: string;
  outcome: string;
  objective: string;
  mode: [];
  promotional_video: string;
  minfees: string;
  maxfees: string;
  cover_image: string;
  live_projects: 'yes';
  password: string;
  publish_category: string;
  publish_tag:string;
  write_password:any;
}